import {
  LABELS,
  DEFAULT_PROMO_BLOCK,
  DEFAULT_PRODUCT_SLIDER,
  transformBannersToBannerBlock,
} from '../lib'
import { useHomepage } from '../state'
import { BannerSlider } from './BannerSlider'
import { CategoryCardsGrid } from './CategoryCards'
import { HomepageSlot } from './HomepageSlot'
import { ProductSlider } from './ProductSlider'
import { PromoBlock } from './PromoBlock'

export function HomepageSections() {
  const { banners, productSliders, promoBlocks, categoryCards, isLoading, error } = useHomepage()

  // Transform domain types to block types
  // React Compiler auto-memoizes based on banners reference
  const bannerBlockData = transformBannersToBannerBlock(banners)

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-red-600">{LABELS.HOMEPAGE_LOADING_ERROR}</p>
        <p className="text-gray-500 text-sm mt-2">
          {error instanceof Error ? error.message : String(error)}
        </p>
      </div>
    )
  }

  return (
    <div className="homepage-sections">
      {/* 1. Banner Slider - no bg, full-bleed */}
      <HomepageSlot name="BannerSlider" errorMessage={LABELS.BANNER_SLIDER_ERROR} kind="banner">
        <BannerSlider banners={bannerBlockData} isLoading={isLoading} />
      </HomepageSlot>

      {/* 2. Category Cards  */}
      {categoryCards.length > 0 && (
        <HomepageSlot name="CategoryCards" errorMessage={LABELS.CATEGORY_CARDS_ERROR} kind="category">
          <CategoryCardsGrid cards={categoryCards} isLoading={isLoading} />
        </HomepageSlot>
      )}

      {/* 3. First PromoBlock (if exists) */}
      {(promoBlocks[0] || isLoading) && (
        <HomepageSlot name="PromoBlock-1" errorMessage={LABELS.PROMO_BLOCK_ERROR} kind="promo">
          <PromoBlock
            key={promoBlocks[0]?.id ?? 'promo-skeleton-1'}
            block={promoBlocks[0] ?? DEFAULT_PROMO_BLOCK}
            isLoading={isLoading}
          />
        </HomepageSlot>
      )}

      {/* 4. First ProductSlider (if exists) */}
      {(productSliders[0] || isLoading) && (
        <HomepageSlot name="ProductSlider-1" errorMessage={LABELS.PRODUCT_SLIDER_ERROR} kind="slider">
          <ProductSlider
            key={productSliders[0]?.id ?? 'slider-skeleton-1'}
            slider={productSliders[0] ?? DEFAULT_PRODUCT_SLIDER}
            isLoading={isLoading}
          />
        </HomepageSlot>
      )}

      {/* 5. Second PromoBlock (if exists) */}
      {promoBlocks[1] && (
        <HomepageSlot name="PromoBlock-2" errorMessage={LABELS.PROMO_BLOCK_ERROR} kind="promo">
          <PromoBlock key={promoBlocks[1].id} block={promoBlocks[1]} />
        </HomepageSlot>
      )}

      {/* 6. Remaining PromoBlocks */}
      {promoBlocks.slice(2).map((block) => (
        <HomepageSlot
          key={block.id}
          name={`PromoBlock-${block.id}`}
          errorMessage={LABELS.PROMO_BLOCK_ERROR}
          kind="promo"
        >
          <PromoBlock block={block} />
        </HomepageSlot>
      ))}

      {/* 7. Remaining ProductSliders */}
      {productSliders.slice(1).map((slider) => (
        <HomepageSlot
          key={slider.id}
          name={`ProductSlider-${slider.id}`}
          errorMessage={LABELS.PRODUCT_SLIDER_ERROR}
          kind="slider"
        >
          <ProductSlider slider={slider} />
        </HomepageSlot>
      ))}
    </div>
  )
}
